module.exports = __webpack_public_path__ + "img/calendar.a76df2e3.svg";